import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d333c060"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "o-aspect-ratio-4/3 bg-wild-sand" }
const _hoisted_2 = { class: "w-full" }

import { VariantImageVersion } from '@/b2c/shared/api/server-apis';
import { computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'WishlistThumbView',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as {
    items: VariantImageVersion[],
}



const cappedItems = computed(() => {
    const items = props.items.slice(0, 3);
    if (items.length < 1) {
        items.push({ sku: 'logo', imageVersion: 0 });
    }
    return items;
});


return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!
  const _component_ProductImage = _resolveComponent("ProductImage")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cappedItems), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.sku,
          class: _normalizeClass(["image", {'image--single': _unref(cappedItems).length === 1}])
        }, [
          _createElementVNode("div", _hoisted_2, [
            (item.sku === 'logo')
              ? (_openBlock(), _createBlock(_component_c_icon, {
                  key: 0,
                  name: "icon-bolia-logo",
                  class: "w-full text-dusty-grey px-10"
                }))
              : (_openBlock(), _createBlock(_component_ProductImage, {
                  key: 1,
                  sku: item.sku,
                  "bg-color": "#f5f5f5",
                  "aspect-ratio": 5/3,
                  "width-on-screen": 1,
                  "cache-bust": item.imageVersion
                }, null, 8, ["sku", "cache-bust"]))
          ])
        ], 2))
      }), 128))
    ])
  ]))
}
}

})